import camelcaseKeys from 'camelcase-keys'

import { handleFetch } from './fetch'

interface InferredParameterCountResponse {
  parameterCount: number | null
}

const inferParameterCountFromIdentifier = async (identifier: string): Promise<number | null> => {
  try {
    const response = await handleFetch('/llm/model-parameter-count', {
      method: 'POST',
      body: {
        path_or_repo_id: identifier,
      },
    })
    const responsePayload = camelcaseKeys(await response.json(), {
      deep: true,
    }) as InferredParameterCountResponse
    if (
      typeof responsePayload.parameterCount !== 'number' ||
      !Number.isFinite(responsePayload.parameterCount)
    ) {
      return null
    }
    return responsePayload.parameterCount
  } catch (error) {
    console.warn('Unable to infer model parameter count from server', error)
    return null
  }
}

export { inferParameterCountFromIdentifier }
